import { ControlProps, isDescriptionHidden } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";

import { Checkbox } from "@/components/primitives/Checkbox";
import { InputDescription } from "@/components/primitives/InputDescription";
import FieldLabel from "@/components/primitives/InputLabel";
import InputErrorTooltip from "@/components/elements/InputErrorTooltip";

function CheckboxControlComponent({
  data,
  handleChange,
  path,
  label,
  description,
  errors,
  visible,
  enabled,
  required,
  config,
}: ControlProps) {
  if (!visible) return null;

  const showDescription = !isDescriptionHidden(
    visible,
    description,
    false,
    config?.showUnfocusedDescription,
  );
  const hasError = errors !== undefined && errors.length > 0;

  return (
    <div>
      <FieldLabel required={required} className="flex items-center gap-3">
        <Checkbox
          checked={!!data}
          onChange={(e) => handleChange(path, e.target.checked)}
          disabled={!enabled}
        />
        <span className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
          {label}
        </span>
        {hasError && (
          <InputErrorTooltip
            iconClassNames="w-5"
            error={label + " " + errors}
          />
        )}
      </FieldLabel>
      {showDescription && description && (
        <InputDescription className="text-xs">{description}</InputDescription>
      )}
    </div>
  );
}

export const CheckboxControl = withJsonFormsControlProps(
  CheckboxControlComponent,
);
